/**
 * File Operation Constants
 *
 * Re-exports from centralized constants for backward compatibility
 * @deprecated Import directly from '@/lib/constants' instead
 */

export { MAX_FILE_SIZE, ALLOWED_FILE_TYPES } from '@/lib/constants/file-limits';
